jQuery(document).ready(function($) {
  require('./components/mobile-header.js');
  require('./components/slider.js');
  require('./components/header-scroll.js');
  require('./components/accordion.js');
  require('./components/learn-more.js');

  loadMorePosts.init();
});


// AOS
AOS.init();


// Footer Padding + Margin If CTA Element Exists
function addPaddingToFooter() {
  var callToAction = document.querySelector('.call-to-action');

  if(callToAction) {
    var callToActionHeight = callToAction.offsetHeight;
    var paddingValue = callToActionHeight / 2;

    var previousSection = callToAction.previousElementSibling;
    var footer = document.querySelector('footer');

    if(previousSection) {
      if(window.innerWidth >= 1024) {
        previousSection.style.paddingBottom = (paddingValue + 80) + 'px';
        previousSection.style.marginBottom = -paddingValue + 'px';

      } else {
        previousSection.style.paddingBottom = (paddingValue + 60) + 'px';
        previousSection.style.marginBottom = -paddingValue + 'px';
      }
    }

    footer.style.paddingTop = paddingValue + 'px';
    footer.style.marginTop = -paddingValue + 'px';
  }
}

document.addEventListener('DOMContentLoaded', addPaddingToFooter);
window.addEventListener('resize', addPaddingToFooter);


// Share Message
var copyLinkButton = document.getElementById('copyLinkButton');
if(copyLinkButton) {
  copyLinkButton.addEventListener('click', function(event) {
    event.preventDefault();
    copyToClipboard(window.location.href);
    showCopiedMessage(); // Show the message
  });
}

function copyToClipboard(text) {
  var textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}

function showCopiedMessage() {
  var message = document.createElement("div");
  message.textContent = "Link copied to clipboard!";
  message.style.position = "fixed";
  message.style.bottom = "10px";
  message.style.left = "10px";
  message.style.padding = "10px";
  message.style.background = "#101010";
  message.style.color = "#fff";
  message.style.borderRadius = "5px";
  message.style.opacity = "0";
  message.style.transition = "opacity 0.3s ease-in-out";

  document.body.appendChild(message);

  setTimeout(function() {
    message.style.opacity = "1";
  }, 100);

  setTimeout(function() {
    message.style.opacity = "0";
    setTimeout(function() {
      document.body.removeChild(message);
    }, 300);
  }, 3000);
}


// Load More Posts
var loadMorePosts = {
	init: function() {
    jQuery('#load-more').click(function(){
      loadMorePosts.loadMore();
    });
	},

	loadMore: function() {
		var loadContainer = jQuery('#load-container');
		var postCount = jQuery('#load-container .post-thumbnail').length;
		var totalPosts = loadContainer.data('total');

		if(postCount >= totalPosts) {
			return;
		}

		var data = {
      action: 'load_more_posts',
      post_count: postCount,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
		};

		jQuery.ajax({
			url: posts.ajaxurl,
			type: "POST",
			data: data,
			beforeSend: function () {
				jQuery('#load-more').addClass('loading');
			},

			complete: function () {
				jQuery('#load-more').removeClass('loading');
			},

			success: function(data) {
				if(data) {
          loadContainer.append(data);
				}

				postCount = jQuery('#load-container .post-thumbnail').length;

				if(postCount >= totalPosts) {
          jQuery('#load-more').replaceWith('<a class="frontend-button main-color-button load-button no-posts" href="#load-more-top">Back To Top</a>');
				}

				return;
			}
		});
	}
}


// Stat Counter
jQuery(document).ready(function($) {
  // Function to change < and > characters to green
  function colorizeCharacters() {
    $('.counting-stat .stat-value').each(function() {
      var htmlContent = $(this).html();
      var modifiedHtml = htmlContent.replace(/&lt;/g, '<span class="green">&lt;</span>')
        .replace(/&gt;/g, '<span class="green">&gt;</span>');
      $(this).html(modifiedHtml);
    });
  }

  colorizeCharacters();

  var isCounting = false;

  $(window).on('scroll', function() {
    if (!isCounting) {
      $('.counting-stat').each(function() {
        if ($(this).isInViewport()) {
          var counts = $(this).find('.stat-value');

          counts.each(function(index) {
            var count = $(this);
            var originalHtml = count.html();
            var text = count.text();
            var numericPart = text.match(/[\d.,]+/g); // Extract numeric part
            var endVal = parseFloat(numericPart[0].replace(/,/g, '')); // Remove commas if any

            // If numeric part found, animate it
            if(numericPart) {
              var duration = 2000;

              $({ countNum: 0 }).animate({ countNum: endVal }, {
                duration: duration,
                easing: 'linear',
                step: function() {
                  // Preserve the green span elements
                  var greenText = originalHtml.replace(/&lt;/g, '<span class="green">&lt;</span>')
                    .replace(/&gt;/g, '<span class="green">&gt;</span>');
                  count.html(greenText.replace(/[\d.,]+/g, Math.floor(this.countNum)));
                },
                complete: function() {
                  // Add commas back and reapply green span styling
                  var greenText = originalHtml.replace(/&lt;/g, '<span class="green">&lt;</span>')
                    .replace(/&gt;/g, '<span class="green">&gt;</span>');
                  count.html(greenText.replace(/[\d.,]+/g, endVal.toLocaleString()));
                }
              });
            }
          });

          isCounting = true;
        }
      });
    }
  });

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
});


// Number Countup Animation
jQuery(document).ready(function($) {
  var isCounting = false;

  $(window).on('scroll', function() {
    if(!isCounting) {
      $('.ebook-data-col').each(function() {
        if($(this).isInViewport()) {
          var counts = $(this).find('.data');

          counts.each(function(index) {
            var count = $(this);
            var text = count.text();
            var numericPart = text.match(/[\d.,]+/g); // Extract numeric part
            var endVal = parseFloat(numericPart[0].replace(/,/g, '')); // Remove commas if any

            // If numeric part found, animate it
            if(numericPart) {
              var duration = 2000;

              $({countNum: 0}).animate({countNum: endVal}, {
                duration: duration,
                easing:'linear',
                step: function() {
                  count.text(text.replace(/[\d.,]+/g, Math.floor(this.countNum)));
                },
                complete: function() {
                  count.text(text.replace(/[\d.,]+/g, endVal.toLocaleString())); // Add commas back
                }
              });
            }
          });

          isCounting = true;
        }
      });
    }
  });

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
});


// Simple Parallax
var images = document.querySelectorAll('.two-columns-full-width .img-container img');
new simpleParallax(images);


// Custom Bold Title
function wrapLastTwoWordsWithSpan() {
  var elements = document.querySelectorAll('.bold-title');

  elements.forEach(function(element) {
    var text = element.textContent.trim().split(' ');

    if(text.length >= 2) {
      var lastTwoWords = text.slice(-2).join(' ');

      element.innerHTML = text.slice(0, -2).join(' ') + ' <span>' + lastTwoWords + '</span>';
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  wrapLastTwoWordsWithSpan();
});


// Parallax Scroll
jQuery(function($) {
  $(document).ready(function() {
    var parallaxElement = $(".parallax-scroll"),
    parallaxQuantity = parallaxElement.length;

    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
        windowTop = $(window).scrollTop(),
        elementTop = currentElement.offset().top,
        elementHeight = currentElement.height(),
        viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
        scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.1 + "px, 0)"
        });
      }
    });

    $(window).on("scroll", function() {
      window.requestAnimationFrame(function() {
        for (var i = 0; i < parallaxQuantity; i++) {
          var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
          currentElement.css({
            transform: "translate3d(0," + scrolled * -0.1 + "px, 0)"
          });
        }
      });
    });
  });
});